import { render, staticRenderFns } from "./ProdutoDialog.vue?vue&type=template&id=4478f4c0&scoped=true"
import script from "./ProdutoDialog.vue?vue&type=script&lang=js"
export * from "./ProdutoDialog.vue?vue&type=script&lang=js"
import style0 from "./ProdutoDialog.vue?vue&type=style&index=0&id=4478f4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4478f4c0",
  null
  
)

export default component.exports